import React, { Component } from 'react'

class ExtendDrawBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      map: null,
      elContainer: null,
      buttons: this.props.buttons || [],
    }
  }

  onAdd(map) {
    this.state.map = map
    const elContainer = this.props.draw.onAdd(map)
    this.state.elContainer = elContainer
    this.state.buttons.forEach((button) => {
      this.addButton(button)
    })
    return elContainer
  }

  onRemove(map) {
    this.state.buttons.forEach((button) => {
      this.removeButton(button)
    })
    this.props.draw.onRemove(map)
  }

  addButton(opt) {
    const elButton = document.createElement('button')
    elButton.className = 'mapbox-gl-draw_ctrl-draw-btn'
    elButton.title = opt.title
    if (opt.classes instanceof Array) {
      opt.classes.forEach((c) => {
        elButton.classList.add(c)
      })
    }
    elButton.addEventListener(opt.on, opt.action)
    this.state.elContainer.appendChild(elButton)
    opt.elButton = elButton
  }

  removeButton(opt) {
    opt.elButton.removeEventListener(opt.on, opt.action)
    opt.elButton.remove()
  }

  render() {
    return null
  }
}

export default ExtendDrawBar
